import axios from "axios";
import NProgress from "nprogress";
import Vue from "vue";
const client = axios.create({
  baseURL: Vue.prototype.$apiUrl,
  withCredentials: false
});

client.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

client.interceptors.response.use((response) => {
  return response;
}, (error) => {
  return Promise.reject(error.response);
});

// Course
function Update(course) {
  return client.put("courses.php", course);
}

function Create(course) {
  course.action = "create";
  return client.post("courses.php", course);
}

function GetCourse(id) {
  const params = {
    id: id,
    action: "course"
  };
  return client.get("courses.php", { params });
}

function GetCourses() {
  const params = {
    action: "courses"
  };
  return client.get("courses.php", { params });
}

function GetActiveCourses() {
  const params = {
    action: "acourses"
  };
  return client.get("courses.php", { params });
}

function Delete(id) {
  const params = {
    id: id
  };
  return client.delete("courses.php", { params });
}
// End Course

// Stage
function UpdateStage(stage) {
  return client.put("stages.php", stage);
}

function CreateStage(stage) {
  stage.action = "create";
  return client.post("stages.php", stage);
}

function GetStage(id) {
  const params = {
    id: id,
    action: "stage"
  };
  return client.get("stages.php", { params });
}

function GetStages(id) {
  const params = {
    action: "stages",
    id: id
  };
  return client.get("stages.php", { params });
}

function DeleteStage(id) {
  const params = {
    id: id
  };
  return client.delete("stages.php", { params });
}
// End Stage

// Lesson
function UpdateLesson(lesson) {
  return client.put("lessons.php", lesson);
}

function CreateLesson(lesson) {
  lesson.action = "create";
  return client.post("lessons.php", lesson);
}

function GetLesson(id) {
  const params = {
    id: id,
    action: "lesson"
  };
  return client.get("lessons.php", { params });
}

function GetLessonsByStage(id) {
  const params = {
    action: "lessonsbystages",
    id: id
  };
  return client.get("lessons.php", { params });
}

function GetLessonsByCourse(id) {
  const params = {
    action: "lessonsbycourse",
    id: id
  };
  return client.get("lessons.php", { params });
}

function DeleteLesson(id) {
  const params = {
    id: id
  };
  return client.delete("lessons.php", { params });
}
// End Lesson

// Lesson Task
function UpdateLessonTask(lesson) {
  return client.put("lessontasks.php", lesson);
}

function CreateLessonTask(lesson) {
  lesson.action = "create";
  return client.post("lessontasks.php", lesson);
}

function GetLessonTask(id) {
  const params = {
    action: "task",
    id: id
  };
  return client.get("lessontasks.php", { params });
}

function GetLessonTasks(id) {
  const params = {
    action: "tasks",
    id: id
  };
  return client.get("lessontasks.php", { params });
}

function DeleteLessonTask(id) {
  const params = {
    id: id
  };
  return client.delete("lessontasks.php", { params });
}
// End Lesson Task
export {
  GetCourses,
  GetCourse,
  Update,
  Create,
  Delete,
  GetStages,
  GetStage,
  UpdateStage,
  CreateStage,
  DeleteStage,
  GetLesson,
  GetLessonsByCourse,
  GetLessonsByStage,
  UpdateLesson,
  CreateLesson,
  DeleteLesson,
  GetLessonTask,
  GetLessonTasks,
  UpdateLessonTask,
  CreateLessonTask,
  DeleteLessonTask,
  GetActiveCourses
};
